import React from 'react';
import PropTypes from 'prop-types';
import GetCoinBalance from '../../hooks/fetch-hooks/get-coin-balance/get-coin-balance';

export default function PillCoins({ userId }) {
    const { data, isLoading } = GetCoinBalance(userId);

    const balance = data?.data?.data || {};
    const current = isLoading ? '...' : (balance.currentAmount ?? 0);
    const earned = isLoading ? '...' : (balance.earned ?? 0);
    const spent = isLoading ? '...' : (balance.spent ?? 0);

    return (
        <div className="mt-6 flex flex-row flex-wrap gap-8">
            <h2 className="flex flex-col font-sans">
                <span className="text-[#168c7c] font-bold text-lg font-sans">Pill Coins (Balance)</span>
                <span className="text-2xl font-bold">{current}</span>
            </h2>
            <h2 className="flex flex-col font-sans">
                <span className="text-[#168c7c] font-bold text-lg font-sans">Total Earned</span>
                {earned}
            </h2>
            <h2 className="flex flex-col font-sans">
                <span className="text-[#168c7c] font-bold text-lg font-sans">Total Spent</span>
                {spent}
            </h2>
        </div>
    );
}

PillCoins.propTypes = {
    userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
